#import "../../../../graphql/fragments/sales-automation-stageset.graphql"

mutation CreateAccountAssignmentAutomation(
    $automation: CreateClosedLeadAccountTypeAutomationInputFieldInput!
) {
    createClosedLeadAccountTypeAutomation(input: {closedLeadAccountTypeAutomation: $automation}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
